import { z } from 'zod';

export const assignRoleDto = z.object({
  roleIds: z.array(z.string().uuid()),
  userIds: z.array(z.string().uuid()),
});

export type AssignRoleDto = z.infer<typeof assignRoleDto>;
